module.exports = __webpack_public_path__ + "img/Ellipse2.aec9ff31.png";